import { render, staticRenderFns } from "./ListTableCertificate.vue?vue&type=template&id=33e773b4&scoped=true&"
import script from "./ListTableCertificate.vue?vue&type=script&lang=js&"
export * from "./ListTableCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e773b4",
  null
  
)

export default component.exports